<template>
	<div class="selectList">
		<b-form-group :label="$t('components.kSelectList.destinationStep')">
			<b-form-select
				class="exitsList"
				type="dropdown"
				:options="options"
				v-model="proxyValue"
				:text-field="textField"
				:value-field="valueField"
			></b-form-select>
		</b-form-group>

		<b-icon
			icon="trash"
			v-if="!hideIcon"
			class="trash-icon"
			@click="$emit('deleteItem', value)"
			v-b-tooltip.hover="{
				title: $t('buttons.erase'),
				customClass: 'custom-tooltip',
				interactive: false,
				placement: 'bottom'
			}"
		/>
	</div>
</template>

<script>
export default {
	props: {
		options: {
			type: Array
		},
		value: {
			type: Number
		},
		valueField: {
			type: String
		},
		textField: {
			type: String
		},
		hideIcon: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
			}
		}
	}
};
</script>
<style scoped>
.trash-icon {
	align-self: center;
	width: 10%;
	font-size: 20px;
	color: #dd3232;
	margin-top: 10px;
}

.trash-icon:hover {
	color: #f73939;
	cursor: pointer;
}

.selectList {
	display: inline-flex;
	margin-inline: 16px;
	/* margin-bottom: 27px; */
	width: 93%;
}

fieldset {
	width: 100%;
}
</style>
